"use client"

import Image from "next/image";
import Upload from "../shared/upload";
import UploadModal from "../shared/uploadModal";
import { useState } from "react";
// import classNames from "classNames";



interface BannerHomeProps {
    title: string;
    subtitle: string;
    ticks: string[];
    uploadButtonText: string;
    uploadSubTitle?: string;
    uploadImage?: string;
    uploadFileTypes?: string[];
    uploadMultiple?: boolean;
}

function classNames(...classes: string[]) {
    return classes.filter(Boolean).join(' ')
}

export default function BannerHome(props: BannerHomeProps) {
    const [showModal, setShowModal] = useState(false);
    const [showSizeLimitError, setShowSizeLimitError] = useState(false);


    const onSizeLimit = () => {
        setShowSizeLimitError(true);
    }



    // const fileTypes = ["PDF"];
    const uploadFileTypes = props.uploadFileTypes || ["PDF"];
    const uploadImage = props.uploadImage || "/img/pdf-icon.svg";
    const uploadSubTitle = props.uploadSubTitle || "Drop PDF Here";
    const uploadMultiple = props.uploadMultiple === null || props.uploadMultiple === undefined ? true : props.uploadMultiple;

    return (
        <section className="hero section-bg-gap w-full bg-neutral-300">
            <div className="container ">
                <div className="hero__wrapper">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="content-box">
                                <h1 className="main-heading pt-2" itemProp="name">{props.title}</h1>
                                <p className="content-box__desc main-desc">{props.subtitle}</p>
                                <div className="lg:mt-5 2xl:mt-5 xl:mt-5 md:mt-5 sm:mt-5 mt-3 mt-lg-500 fs-2">
                                    <ul>
                                        {props.ticks && props.ticks.map((tick: string, index: number) =>
                                            <>
                                                <li className="point-check pt-3" key={index.toString()}> {tick}</li>
                                            </>
                                        )}
                                    </ul>
                                    <div className={classNames(" text-red-600 pt-10",
                                        showSizeLimitError ? "block" : "hidden")}>
                                        {showSizeLimitError ?
                                            <span>The file exceed our limit of 20MB. Please contact support@usepdf.com for help</span>
                                            : <span></span>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5  ms-auto">
                            <div className="hero__box-wrapper box-shadow d-flex justify-content-center flex-col">
                                <Upload
                                    buttonText={props.uploadButtonText}
                                    title="Upload Your Files"
                                    onSizeLimit={onSizeLimit}
                                    image={uploadImage}
                                    subtitle={uploadSubTitle}
                                    fileTypes={uploadFileTypes}
                                    multiple={uploadMultiple}
                                />

                            </div>

                        </div>

                        {/* <div className="col-lg-6">
                            <div className="hero__box-wrapper box-shadow">
                                <div className="hero__box d-flex flex-column align-items-center">
                                    <div className="">
                                        <Upload
                                            buttonText={props.uploadButtonText}
                                            title="Upload Your Files"
                                            onSizeLimit={onSizeLimit}
                                            image={uploadImage}
                                            subtitle={uploadSubTitle}
                                            fileTypes={uploadFileTypes}
                                            multiple={uploadMultiple}
                                        />
                                    </div>
                                </div>
                                <div className="hero__media-box d-flex justify-content-center gap-2">
                                    <a href="#">
                                        <div className="hero__box-icon box-shadow">
                                            <img className="img-fluid" src="/img/box-icon.svg" alt="drive-icon" />
                                        </div>
                                    </a>
                                    <a href="#">
                                        <div className="hero__box-icon box-shadow">
                                            <img className="img-fluid" src="/img/sky-icon.svg" alt="drive-icon" />
                                        </div>
                                    </a>
                                    <a href="#">
                                        <div className="hero__box-icon box-shadow">
                                            <img className="img-fluid" src="/img/drive-icon.svg" alt="drive-icon" />
                                        </div>
                                    </a>
                                    <a href="#">
                                        <div className="hero__box-icon box-shadow">
                                            <img className="img-fluid" src="/img/blue-sky-icon.svg" alt="drive-icon" />
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div> */}
                        {/* <div className="col-lg-6">
                            <div className="hero__box-wrapper box-shadow">
                                <h2 className="sub-heading text-center mb-200">Upload Your Files</h2>
                                <div className="hero__box d-flex flex-column align-items-center">
                                    <img className="img-fluid" src="img/pdf-icon.svg" alt="pdf-icon" />
                                    <p>Drop PDF Files Here</p>
                                    <div>Or</div>
                                    <button className="mybtn mybtn--primary">UPLOAD YOUR PDF</button>
                                </div>
                                <div className="hero__media-box d-flex justify-content-center gap-2">
                                    <a href="#">
                                        <div className="hero__box-icon box-shadow">
                                            <img className="img-fluid" src="img/box-icon.svg" alt="drive-icon" />
                                        </div>
                                    </a>
                                    <a href="#">
                                        <div className="hero__box-icon box-shadow">
                                            <img className="img-fluid" src="img/sky-icon.svg" alt="drive-icon" />
                                        </div>
                                    </a>
                                    <a href="#">
                                        <div className="hero__box-icon box-shadow">
                                            <img className="img-fluid" src="img/drive-icon.svg" alt="drive-icon" />
                                        </div>
                                    </a>
                                    <a href="#">
                                        <div className="hero__box-icon box-shadow">
                                            <img className="img-fluid" src="img/blue-sky-icon.svg" alt="drive-icon" />
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>

            </div>
            <UploadModal
                title={"Upload Your Files"}
                open={showModal}
                onClose={() => setShowModal(false)}
                buttonText={props.uploadButtonText}
                image={uploadImage}
                subtitle={uploadSubTitle}
                fileTypes={uploadFileTypes}
                multiple={uploadMultiple}
            />
        </section>
    );
}
